import {isSkFieldValuesEqual} from "../SkForm";
import SkFieldProps from "./SkFieldProps";

export const isSkFieldSubmitted = (props: SkFieldProps) =>
  props.submittedValue ? isSkFieldValuesEqual(props.submittedValue, props.formikProps.values[props.name]) : false;

export default isSkFieldSubmitted;